import { v4 as uuidv4 } from "uuid"

export default {
  install: (Vue: any) => {
    Vue.prototype.$uuid = uuidv4

    // 4. adicionar um método de instância
  },
}
